import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import useLocales from 'hooks/useLocales';
import Image from 'components/image/Image';
import Button from 'components/Button/Index';
import { getDateFormatter } from 'helpers/dateConverter';
import { monthlySalary } from 'core/constants/preferenceConstats';

import './Index.scss';
import useAuth from 'hooks/useAuth';

const JobOpeningCard = ({ item }: any): JSX.Element => {
  const { isCandidate } = useAuth();
  const { t } = useLocales();
  const navigate = useNavigate();
  const categoriesRef = useRef<HTMLDivElement>(null);
  const [hasOverflow, setHasOverflow] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (categoriesRef.current) {
        setHasOverflow(
          categoriesRef.current.scrollHeight >
            categoriesRef.current.clientHeight
        );
      }
    };

    checkOverflow();
    // Re-check on window resize
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, [item?.competency_labels, item?.competencies]);

  return (
    <div className="jobOpeningCart">
      <div className="cartHeader">
        <div className="dateContainer">
          {getDateFormatter(item?.created_at, 'DD MMM  YYYY')}
        </div>
      </div>
      <div className="cartBody">
        <p className="typeText">
          {item?.is_remote && 'Remote'}{' '}
          {item?.is_remote && item?.if_office_work && ','}{' '}
          {item?.if_office_work && ' Office work'}
        </p>
        <p className="typeTitle">{item?.title}</p>
        <p className="typeDescription">{item?.description}</p>
        <div className="categories-container">
          <div className="categories" ref={categoriesRef}>
            {item?.competencies?.map((competency: any, index: number) => (
              <div key={index} className="categoryItem">
                {competency?.competency?.name}
              </div>
            ))}
          </div>
          {hasOverflow && (
            <div className="scroll-indicator">
              <Image className="arrow-down" name="down-arrow.svg" />
              <span className="scroll-indicator-text">
                {t('Scroll for more')}
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="cartFooter">
        <div>
          <p>
            {monthlySalary.find((el: any) => el.value == item?.salary)?.to_show}
          </p>
          <span>{item?.hourly_rate && `${item?.hourly_rate}/hour`}</span>
        </div>
        <Button
          className="next"
          title="Details"
          t={t}
          onClick={() =>
            navigate(
              isCandidate
                ? `/job/${item?.id}`
                : `/jobs/${item?.slug || item?.id}`
            )
          }
        />
      </div>
    </div>
  );
};

export default JobOpeningCard;
